(() => {
  const init = scope => {
    const roots = scope.matches?.('[data-catalogue-page]') ? [scope] : scope.querySelectorAll('[data-catalogue-page]');
    roots.forEach(root => {
      if (root.dataset.catalogueReady) return;
      root.dataset.catalogueReady = 'true';
      root.querySelectorAll('[data-catalogue-reader]').forEach(reader => {
        reader.addEventListener('toggle', () => {
          const frame = reader.querySelector('[data-catalogue-frame]');
          if (reader.open && frame && !frame.hasAttribute('src') && frame.dataset.src) frame.src = frame.dataset.src;
        });
      });
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (!reduce.matches) entry.target.classList.add('cat-enter');
        });
      }, {threshold: .1});
      root.querySelectorAll('.cat-intro>div,.cat-heading,.cat-category,.cat-notes h2,.cat-notes article,.cat-recipe,.cat-resources h2,.cat-resources article,.cat-order-note>div').forEach(el => observer.observe(el));
      reduce.addEventListener('change', () => {if (reduce.matches) {observer.disconnect();root.getAnimations({subtree:true}).forEach(animation=>animation.finish());}}, {once:true});
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
